import React from 'react';
import './About.css';
import myPhotoOne from '../../images/MyPhotoOne.png'
import MyPDF from '../../images/Faiyad_Ahmed_Resume.pdf';
import TextAnimation from 'react-animate-text';
import { render } from 'react-dom';
import Typed from 'react-typed';

const About = () => {
    return (

        <div className="about-container row d-flex align-items-center px-5" style={{ height: '900px' }}>
            <div className="col-md-5 position-absolute top-50 start-50">
                <TextAnimation>
                    <main>
                        <h1>Hello, I'm Faiyad Ahmed Sudipto</h1>
                    </main>
                </TextAnimation>
                {/* TextAnimation Link:-  https://github.com/prztrz/react-animate-text#readme */}
                {/* TextAnimation Link:-  https://www.npmjs.com/package/react-animate-text */}
                <h3 className="text-dark">
                    <Typed
                        strings={[
                            'Website Developer',
                            'React Developer',
                            'JavaScript Developer']}
                        typeSpeed={40}
                        backSpeed={50}
                        // attr="placeholder"
                        loop >
                    </Typed>
                </h3>
                {/* Typed Link:-  https://www.npmjs.com/package/react-typed?fbclid=IwAR2OvftFoNndYY4iPD2f2XG_V6QlAW8I5OTgF2wJkW2q1kBshPkP5xQgEE8 */}
                <h5>I am a Junior Web Developer with knowing some framework for the frontend and the backend. I work with JavaScript  React. I build some awesome Websites yet.</h5>
                <a className="btn btn-danger" href={MyPDF} download="Resume Done.pdf">Download</a>
                {/* <a href='https://drive.google.com/file/d/1VB-QwvsCeV6RpUfotysEZbeYbDwhMObG/view?usp=sharing' download>Click to download</a> */}
                {/* <a href="https://drive.google.com/uc?export=download&amp:id=1VB-QwvsCeV6RpUfotysEZbeYbDwhMObG/" role="button" target="_blank"> Download Here </a> */}

            </div>
        </div>
        
    );
};

export default About;